import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_ROLE_DELETE, {
      queryParams: { name: payload.name, service: 'rapidoo-admin' }
    })
  },

  method() {
    return 'POST'
  },

  format(payload) {
    return {}
  },

  parse(raw = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || "Erreur lors de la suppression du rôle",
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Rôle supprimé avec succès',
      data: raw.data,
    }
  },
}
